import { render, staticRenderFns } from "./default.vue?vue&type=template&id=af614710&scoped=true&"
var script = {}
import style0 from "./default.vue?vue&type=style&index=0&id=af614710&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af614710",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Menu: require('/codebuild/output/src3208117147/src/studio-frank/components/global/Menu.vue').default})
